var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { asDefined, Lazy, panic, UUID } from "@opendaw/lib-std";
import { network, Promises } from "@opendaw/lib-runtime";
import { Sample } from "@opendaw/studio-adapters";
import { z } from "zod";
import { WavFile } from "@opendaw/lib-dsp";
export class CustomSampleAPI {
    static Root = import.meta.env?.VITE_CUSTOM_SAMPLE_API_URL ?? "";
    static get() { return new CustomSampleAPI(); }
    constructor() { }
    async all() {
        return network.defaultFetch(`${CustomSampleAPI.Root}/api/samples`)
            .then(response => response.json().then(data => z.array(Sample).parse(data)), () => []);
    }
    async get(uuid) {
        const url = `${CustomSampleAPI.Root}/api/samples/${UUID.toString(uuid)}`;
        const response = await Promises.retry(() => network.limitFetch(url));
        if (!response.ok) {
            return panic(`Sample not found: ${UUID.toString(uuid)}`);
        }
        return Sample.parse(await response.json());
    }
    async load(uuid, progress) {
        return this.get(uuid)
            .then(sample => Promises.retry(() => network.limitFetch(`${CustomSampleAPI.Root}/files/${sample.uuid}`))
            .then(response => {
            if (!response.ok) {
                return panic(`Failed to fetch sample ${sample.uuid}: ${response.status} ${response.statusText}`);
            }
            const total = parseInt(response.headers.get("Content-Length") ?? "0");
            let loaded = 0;
            return new Promise((resolve, reject) => {
                const reader = asDefined(response.body, "No body in response").getReader();
                const chunks = [];
                const nextChunk = ({ done, value }) => {
                    if (done) {
                        resolve(new Blob(chunks).arrayBuffer());
                    }
                    else {
                        chunks.push(value);
                        loaded += value.length;
                        progress(loaded / total);
                        reader.read().then(nextChunk, reject);
                    }
                };
                reader.read().then(nextChunk, reject);
            });
        })
            .then(arrayBuffer => {
            const audioData = WavFile.decodeFloats(arrayBuffer);
            return [audioData, sample];
        }));
    }
    async upload(_arrayBuffer, _metaData) { }
    allowsUpload() { return false; }
}
__decorate([
    Lazy,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", CustomSampleAPI)
], CustomSampleAPI, "get", null);
